import React from 'react';
import { DragIndicator, Edit, MoreHoriz } from '@material-ui/icons';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Menu, MenuItem } from '@material-ui/core';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const MenuListTable = (props) => {
  const {
    handleMenuClick,
    selectedValue,
    uiBuilderMenuList,
    handleClose,
    handleEdit,
    handleRemove,
    onReorderMenu,
  } = props;

  const onClickOption = (e, currMenu) => {
    return handleMenuClick(e, currMenu);
  };

  const onCloseOption = () => {
    return handleClose();
  };

  const onClickEdit = (e, currMenu) => {
    return handleEdit(e, currMenu);
  };

  const onClickRemove = (e, currMenu) => {
    return handleRemove(e, currMenu);
  };

  const onDragEnd = (dragResult) => {
    if (!dragResult.destination) return false;
    return onReorderMenu(dragResult);
  };

  return (
    <div className='col-12 mx-3 mt-1'>
      <div className='col-12 col-md-4'>
        <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
          <Droppable droppableId='droppable'>
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                className='col-12 px-1 py-3'
                ref={provided.innerRef}
              >
                {uiBuilderMenuList?.map((uiBuilderMenu, uiBuilderMenuNdx) => (
                  <Draggable
                    key={uiBuilderMenu.id}
                    draggableId={uiBuilderMenu.id}
                    index={uiBuilderMenuNdx}
                    disabled={true}
                  >
                    {(provided, snapshot) => (
                      <div
                        className='row d-flex'
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div className='menu-list-table row' key={uiBuilderMenuNdx}>
                          <div className='col col-md-2'>
                            <DragIndicator />
                          </div>
                          <div
                            className='col col-md-8'
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {uiBuilderMenu.name.length > 30
                              ? uiBuilderMenu.name.slice(0, 30) + '…'
                              : uiBuilderMenu.name}
                          </div>
                          <div
                            className='col col-md-2'
                            onClick={(e) => onClickOption(e, uiBuilderMenu)}
                          >
                            <MoreHoriz />
                          </div>
                          {selectedValue.id === uiBuilderMenu.id && (
                            <div className='ui-builder-menu-option-pop'>
                              <Menu
                                id={uiBuilderMenuNdx}
                                anchorEl={selectedValue?.anchorEl}
                                disableRestoreFocus
                                MenuListProps={{ autoFocusItem: false }}
                                keepMounted
                                open={Boolean(selectedValue.anchorEl)}
                                onClose={() => onCloseOption()}
                                className='shadow'
                              >
                                <MenuItem
                                  className='pe-4'
                                  onClick={(e) => onClickEdit(e, uiBuilderMenu)}
                                >
                                  <Edit className='me-2 action-menu-icon' />
                                  Edit Details
                                </MenuItem>
                                <MenuItem
                                  className='pe-4'
                                  onClick={(e) => onClickRemove(e, uiBuilderMenu)}
                                >
                                  <DeleteForeverIcon className='me-2 action-menu-icon' />
                                  Remove
                                </MenuItem>
                              </Menu>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};

export default MenuListTable;
